module.exports = __webpack_public_path__ + "static/img/home8.c9e95d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/home8.svg
// module id = k4w/
// module chunks = 1